export default function CartEmpty({ shopUrl }) {
	return (
		<div className="zc-empty">
			<h2 className="zc-empty__title">Your bag is empty</h2>
			<p className="zc-empty__text">
				Nothing in here yet. Browse the shop, or build a racket in the
				configurator and it will land in your bag.
			</p>
			<div className="zc-empty__actions">
				<a href={shopUrl} className="zc-empty__btn zc-empty__btn--primary">
					Shop everything
				</a>
				<a
					href="/product/ezone-100-gen-8/"
					className="zc-empty__btn zc-empty__btn--secondary"
				>
					Build a racket
				</a>
			</div>
		</div>
	);
}
